import { render, staticRenderFns } from "./SPNav.vue?vue&type=template&id=0d36a322&scoped=true&"
import script from "./SPNav.vue?vue&type=script&lang=ts&"
export * from "./SPNav.vue?vue&type=script&lang=ts&"
import style0 from "./SPNav.vue?vue&type=style&index=0&id=0d36a322&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d36a322",
  null
  
)

export default component.exports